import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Input, Select, Popconfirm, Icon, Alert, List } from 'antd'
import TagsCard from '@components/TagsCard'

@inject((store: any) => {
    const { popupStore, drugsStore } = store
    return { popupStore, drugsStore }
})
@observer
export default class DrugAliases extends Component<any, any> {
    state: any = {
        errors: {},
        newAlias: undefined,
        disabled: false
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    handleAliasChange = (value, currentIndex) => {
        const {
            drugsStore: { aliasesArray, changeAliasValue },
            popupStore: {
                info: { name, name_en }
            }
        } = this.props
        changeAliasValue(value, currentIndex)
        const duplicate =
            aliasesArray.find((alias, index) => index !== currentIndex && alias.trim() === value.trim()) ||
            value === name ||
            value === name_en
        if (duplicate) {
            this.setState({ disabled: true, errors: { itemError: { currentIndex, msg: '* שם זה כבר קיים' } } })
        } else {
            this.setState({ errors: {}, disabled: false })
        }
    }

    handleDeleteAlias = index => {
        this.props.drugsStore.deleteAlias(index)
    }

    handChangNewAlias = newAlias => {
        this.setState({ newAlias })
    }

    handleAddNewAlias = () => {
        const { newAlias } = this.state
        const {
            drugsStore: { aliasesArray, addAlias },
            popupStore: {
                info: { name, name_en }
            }
        } = this.props
        if (newAlias) {
            const duplicate =
                aliasesArray.find(alias => alias.trim() === newAlias.trim()) ||
                newAlias === name ||
                newAlias === name_en
            if (!duplicate) {
                addAlias(newAlias)
                this.reset()
            } else {
                this.setState({ errors: { newAlias: '* הערך שהזנת כבר קיים' } })
            }
        } else {
            this.setState({ errors: { newAlias: '* חובה להזין שם' } })
        }
    }

    handleUpdateAliases = async () => {
        const {
            drugsStore: {
                updateDrug,
                getDrugs,
                paging: { page }
            },
            popupStore: {
                info: { id }
            }
        } = this.props
        await updateDrug(id)
        await getDrugs(page)
    }

    reset = () => {
        this.setState({
            errors: {},
            newAlias: undefined,
            disable: false
        })
    }

    render() {
        const { newAlias, errors, disabled } = this.state
        const { popupType, info } = this.props.popupStore
        const { name, name_en, id } = info
        const { aliasesArray } = this.props.drugsStore
        return (
            <Modal
                title={`עריכת שמות מקבילים בתרופה ${name ? name : name_en}`}
                visible={popupType === 'drugAliases'}
                cancelText="ביטול"
                okText="שמור שינויים"
                onCancel={this.closePopup}
                onOk={this.handleUpdateAliases}
                okButtonProps={{ disabled }}
            >
                <form
                    style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}
                    onSubmit={e => {
                        e.preventDefault()
                        this.handleAddNewAlias()
                    }}
                >
                    <Input
                        value={newAlias}
                        disabled={disabled}
                        onChange={e => this.handChangNewAlias(e.target.value)}
                        placeholder="הזנת שם מקביל חדש"
                    />
                    <Button
                        disabled={disabled}
                        type="primary"
                        onClick={this.handleAddNewAlias}
                        style={{ marginRight: '0.5rem', marginLeft: '0' }}
                    >
                        <Icon type="plus" />
                    </Button>
                </form>
                {'newAlias' in errors && <div style={{ color: 'red' }}>{errors.newAlias}</div>}
                <List
                    style={{ padding: '0 0 2rem 0' }}
                    dataSource={aliasesArray}
                    renderItem={(item, index) => {
                        const disabledItem = 'itemError' in errors && errors.itemError.currentIndex !== index
                        return (
                            <List.Item
                                key={index}
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'start',
                                    padding: '0.5rem 0'
                                }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                                    <Input
                                        value={item}
                                        disabled={disabledItem}
                                        onChange={e => this.handleAliasChange(e.target.value, index)}
                                    />
                                    <Button
                                        disabled={disabledItem}
                                        style={{ marginRight: '0.5rem', marginLeft: '0' }}
                                        onClick={() => this.handleDeleteAlias(index)}
                                    >
                                        <Icon type="delete" />
                                    </Button>
                                </div>
                                {'itemError' in errors && errors.itemError.currentIndex === index && (
                                    <div style={{ width: '100%', color: 'red' }}>{errors.itemError.msg}</div>
                                )}
                            </List.Item>
                        )
                    }}
                    pagination={{
                        total: aliasesArray.length,
                        pageSize: 10
                    }}
                />
            </Modal>
        )
    }
}
